export default "__VITE_ASSET__B$MgWaWx__"